/* eslint-disable local-rules/disallow-side-effects */
import { createDisplay } from '@openobserve/js-core/util'

export const display = createDisplay('OpenObserve Browser SDK:')

export const DOCS_ORIGIN = 'https://openobserve.ai'
export const DOCS_TROUBLESHOOTING = `${DOCS_ORIGIN}/docs/user-guide/rum/`
export const MORE_DETAILS = 'More details:'
